import { useEffect, useState, Fragment } from "react";
import {
  Row,
  Col,
  Modal,
  ModalHeader,
  ModalBody,
  Card,
  CardBody,
  CardFooter,
  Button,
  Table,
} from "reactstrap/lib";
import styled from "styled-components";
import { FormattedMessage } from "react-intl";
import CreateAPLPeriodDocuments from "../Modal/CreateAPLPeriodDocuments";
import {
  DeleteDocument,
  GetAplInformationPersons,
  PostAplInformationPerson,
  UpdateInformationPersonAddUsers,
  UpdateInformationPersonRemoveUsers,
  PostInformationPersonsAndUsersForPeriod,
} from "../../actions/teacherMutations";
import { useMutation } from "@tanstack/react-query";
import { toast } from "react-toastify";
import { Tab, Tabs, Box } from "@mui/material";
import ModifyAPLInformationPersonModal from "../Modal/ModifyAPLInformationPersonModal";
import ModifySupervisorsModal from "../Modal/ModifySupervisorsModal";
import { BASE_LOGIN_REDIRECT_URL_NO_LWC } from "../../constants/api.constants";
import ButtonSendActivationMail from "../Button/ButtonSendActivationMail";
import axios from "../../services/api/api";
import { v4 as uuid } from "uuid";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

export default function APLDocumentsAndSupervisors({
  allSupervisors,
  setLevelSupervisor,
  levelSupervisor,
  setSupervisor,
  toggleSupervisorInfo,
  period,
  setPeriod,
  toggleInfoPersonOpen,
  setAplInfoPerson,
  level,
  objId,
  students,
  schoolId,
  programTeachers,
  programId,
  teacherInfo,
}) {
  const deleteDocument = useMutation({ mutationFn: DeleteDocument });
  const { mutate } = useMutation({ mutationFn: GetAplInformationPersons });
  const postAplInfoPerson = useMutation({ mutationFn: PostAplInformationPerson });
  const updateInfoPersonAddUsers = useMutation({ mutationFn: UpdateInformationPersonAddUsers });
  const postAplInfoPersonsAndUsers = useMutation({
    mutationFn: PostInformationPersonsAndUsersForPeriod
  });
  const updateInfoPersonRemoveUsers = useMutation({
    mutationFn: UpdateInformationPersonRemoveUsers
  });

  const [isOpen, setIsOpen] = useState(false);
  const toggle = () => {
    setAplDocumentsWithUsers([]);
    setIsOpen(!isOpen);
  };
  const [informationPersonIsOpen, setInformationPersonIsOpen] = useState(false);
  const [modifySupervisorsOpen, setModifySupervisorsOpen] = useState(false);
  const toggleInformationPerson = () =>
    setInformationPersonIsOpen(!informationPersonIsOpen);
  const toggleSupervisorModifyer = () => {
    setModifySupervisorsOpen(!modifySupervisorsOpen);
  };
  const [aplDocumentsWithUsers, setAplDocumentsWithUsers] = useState([]);
  const [informationPersons, setInformationPersons] = useState([]);
  const [infoPersonUsers, setInfoPersonUsers] = useState([]);
  const [listOfStudentIds, setListOfStudentIds] = useState([]);
  const [allStudents, setAllStudents] = useState([]);
  const [supervisorsInPeriod, setSupervisorsInPeriod] = useState([]);

  const [isTableExpanded, setIsTableExpanded] = useState(false);
  const tableLimit = 5;

  useEffect(() => {
    if (period?.period) {
      const tempSupervisorsInPeriod = [];
      period.period.students.forEach((stud) => {
        stud.supervisors.forEach((sv) => {
          tempSupervisorsInPeriod.push({ ...sv.supervisor });
        });
      });
      setSupervisorsInPeriod(tempSupervisorsInPeriod);
    }
  }, [period]);

  useEffect(() => {
    const tempAllStudents = [];
    students.forEach((stud) => {
      const studentToAdd = {
        company: null,
        companyId: null,
        id: stud.id,
        period: null,
        periodId: null,
        student: stud,
        studentId: stud.id,
        supervisor: null,
        supervisorId: null,
      };
      tempAllStudents.push(studentToAdd);
    });
    setAllStudents(tempAllStudents);
  }, [students]);

  useEffect(() => {
    let studentIds = [];
    students.forEach((stud) => {
      studentIds.push(stud.id);
    });
    setListOfStudentIds(studentIds);
  }, [students]);

  useEffect(() => {
    mutate(period.period.id, {
      onSuccess: (data) => {
        setInformationPersons(data);
      },
      throwOnError: true,
      onError: (data) => {
        toast.warn(data.response.data);
      },
    });
  }, [period, mutate]);

  const selectSupervisorDocument = (sl) => {
    switch (sl) {
      case "supervisor":
        const studentList = period?.period?.students || [];
        const displayStudents = isTableExpanded
          ? studentList
          : studentList.slice(0, tableLimit);

        return (
          <>
            <div className="apl-content">
              <div className="d-flex flex-column">
                <Table
                  responsive
                  hover
                  size="sm"
                  className="mb-0 align-middle apl-table--borderless"
                >
                  <thead className="bg-light">
                    <tr>
                      <th
                        className="ps-3 py-2 text-muted"
                        style={{ width: "40%" }}
                      >
                        <FormattedMessage id="Student" />
                      </th>
                      <th className="py-2 text-muted">
                        <FormattedMessage id="Supervisors" />
                      </th>
                    </tr>
                  </thead>

                  <tbody>
                    {displayStudents.map((stud) => {
                      return (
                        <tr key={stud.student.id}>
                          <td className="ps-3 pt-2 align-top">
                            {stud.student.name}
                          </td>
                          <td className="pt-1 align-top">
                            {stud.supervisors?.map((sv) => (
                              <div
                                key={sv.supervisor.id}
                                className="d-flex align-items-center justify-content-between mb-1 pe-2 bg-light-hover"
                              >
                                <Button
                                  onClick={() => {
                                    setSupervisor(sv.supervisor);
                                    toggleSupervisorInfo();
                                  }}
                                  title={sv.supervisor.name}
                                  color="link"
                                  className="p-0 text-decoration-none text-primary small text-start"
                                >
                                  <FontAwesomeIcon
                                    icon="user-tie"
                                    className="me-2 text-muted"
                                    style={{ marginBottom: "0.1rem" }}
                                    size="xs"
                                  />
                                  {sv.supervisor.name}
                                </Button>

                                <ButtonSendActivationMail
                                  user={{
                                    email: sv.supervisor.email,
                                    activatedAccount:
                                      sv.supervisor.activatedAccount,
                                  }}
                                  leftAlign={false}
                                  printButtonText={false}
                                />
                              </div>
                            ))}
                          </td>
                        </tr>
                      );
                    })}
                  </tbody>
                </Table>

                {studentList.length > tableLimit && (
                  <div className="text-center py-2">
                    <Button
                      color="link"
                      size="sm"
                      className="text-decoration-none"
                      onClick={() => setIsTableExpanded(!isTableExpanded)}
                    >
                      <FontAwesomeIcon
                        icon={isTableExpanded ? "chevron-up" : "chevron-down"}
                        className="me-1"
                      />
                      {isTableExpanded ? (
                        <FormattedMessage id="ShowLess" />
                      ) : (
                        <FormattedMessage id="ShowAll" />
                      )}
                    </Button>
                  </div>
                )}
              </div>

              <ModifySupervisorsModal
                allSupervisors={allSupervisors}
                isOpen={modifySupervisorsOpen}
                toggle={toggleSupervisorModifyer}
                allStudents={allStudents}
                period={period}
                listOfStudentIds={listOfStudentIds}
                schoolId={schoolId}
                level={level}
                objId={objId}
                programTeachers={programTeachers}
                programId={programId}
                teacherInfo={teacherInfo}
              />
            </div>

            <CardFooter>
              <div className="d-flex justify-content-end py-1">
                <Button
                  color="primary"
                  outline
                  onClick={toggleSupervisorModifyer}
                >
                  <FontAwesomeIcon icon="edit" className="me-2" />
                  <FormattedMessage id="EditSupervisorsAndStudents" />
                </Button>
              </div>
            </CardFooter>
          </>
        );
      case "documents":
        const documentsForLevelUsers = period.documents.filter((doc) => {
          const hasStudentAccess = doc.documentAccesses.some(
            (user) =>
              user.userType === "Student" &&
              students.some((stud) => stud.id === user.id)
          );

          const hasAplSupervisorWithCorrectAccess =
            doc.documentAccesses.every(
              (user) => user.userType === "AplSupervisor"
            ) ||
            doc.documentAccesses.some(
              (user) =>
                user.userType === "AplSupervisor" &&
                students.some((stud) => stud.id === user.id)
            );
          return hasStudentAccess || hasAplSupervisorWithCorrectAccess;
        });
        return (
          <>
            <div className="apl-content">
              {period &&
                documentsForLevelUsers.map((value, index) => {
                  var docName =
                    value.description?.length > 0
                      ? value.description
                      : value.documentPath.split("\\")[2].split(".")[0];
                  return (
                    <Row
                      key={uuid()}
                      style={{
                        margin: ".2rem",
                        paddingLeft: "1rem",
                        paddingRight: "1rem",
                        paddingBottom: "0",
                        paddingTop: ".3rem",
                      }}
                    >
                      <Col className="flex-grow-0">
                        <Button
                          color="danger"
                          outline
                          size="sm"
                          style={{
                            cursor: "pointer",
                          }}
                          onClick={() => {
                            deleteDocument.mutate(value.id, {
                              onSuccess: () => {
                                setPeriod(prev => ({
                                  ...prev,
                                  documents: prev.documents.filter((_, i) => i !== index)
                                }));
                              },
                              throwOnError: true,
                              onError: (data) => {
                                toast.warn(data.response.data);
                              },
                            });
                          }}
                        >
                          <FontAwesomeIcon icon="trash" />
                        </Button>
                      </Col>
                      <Col>
                        <LabelAsRow
                          style={{
                            marginTop: "0",
                            marginRight: "0",
                            marginBottom: "0",
                            marginLeft: "-1rem",
                            borderRadius: "5px",
                          }}
                          onClick={() =>
                            window.open(
                              BASE_LOGIN_REDIRECT_URL_NO_LWC +
                                "/" +
                                value.documentPath,
                              "_blank"
                            )
                          }
                        >
                          {" "}
                          <Col
                            style={{
                              background: "transparent",
                              paddingLeft: "0",
                            }}
                          >
                            <Label
                              style={{
                                margin: "0",
                                background: "transparent",
                                cursor: "pointer",
                              }}
                            >
                              {docName}
                            </Label>

                            {value.documentAccesses.some(
                              (acc) => acc.userType === "Student"
                            ) && (
                              <>
                                <span className="small ps-3 pe-1">
                                  <FormattedMessage id="Students" />:
                                </span>
                                {value.documentAccesses
                                  .filter((acc) => acc.userType === "Student")
                                  .map((access, i) => {
                                    return (
                                      <span className="small" key={access.id}>
                                        {access.name}
                                        {value.documentAccesses.filter(
                                          (acc) => acc.userType === "Student"
                                        ).length -
                                          1 ===
                                        i
                                          ? ". "
                                          : ", "}
                                      </span>
                                    );
                                  })}
                              </>
                            )}
                            {value.documentAccesses.some(
                              (acc) => acc.userType === "AplSupervisor"
                            ) && (
                              <>
                                <span className="small ps-3 pe-1">
                                  <FormattedMessage id="Supervisors" />:
                                </span>
                                {value.documentAccesses
                                  .filter(
                                    (acc) => acc.userType === "AplSupervisor"
                                  )
                                  .map((access, i) => {
                                    return (
                                      <span className="small" key={access.id}>
                                        {access.name}
                                        {value.documentAccesses.filter(
                                          (acc) =>
                                            acc.userType === "AplSupervisor"
                                        ).length -
                                          1 ===
                                        i
                                          ? ". "
                                          : ", "}
                                      </span>
                                    );
                                  })}
                              </>
                            )}
                          </Col>
                        </LabelAsRow>
                      </Col>
                    </Row>
                  );
                })}
            </div>
            <CardFooter>
              <div className="justify-content-end d-flex py-1">
                <Button outline color="primary" onClick={toggle}>
                  <FontAwesomeIcon icon="plus" className="me-2" />
                  <FormattedMessage id="AddDocuments" />
                </Button>
              </div>
            </CardFooter>
          </>
        );
      case "importantPersons":
        return (
          <>
            <div className="apl-content">
              <Col>
                {informationPersons &&
                  informationPersons
                    .filter(
                      (infoPerson) =>
                        infoPerson.forUserIds.length > 0 &&
                        (level === "Student" && infoPerson.forUserIds
                          ? infoPerson.forUserIds.includes(objId)
                          : true)
                    )
                    .map((infoPerson, i) => {
                      return (
                        <Fragment key={uuid()}>
                          <LabelAsRow
                            style={{
                              margin: ".2rem",
                              padding: "1rem",
                              paddingBottom: "0",
                              paddingTop: ".3rem",
                              paddingLeft: ".3rem",
                            }}
                            onClick={() => {
                              setAplInfoPerson(infoPerson);
                              toggleInfoPersonOpen();
                            }}
                          >
                            <Col
                              style={{
                                background: "transparent",
                                paddingLeft: "0",
                              }}
                            >
                              <Label
                                style={{
                                  margin: "0",
                                  background: "transparent",
                                  cursor: "pointer",
                                }}
                              >
                                {infoPerson.name}
                              </Label>
                            </Col>
                          </LabelAsRow>
                          <br />
                        </Fragment>
                      );
                    })}
              </Col>
            </div>
            <CardFooter>
              <div className="justify-content-end d-flex py-1">
                <Button
                  outline
                  color="primary"
                  onClick={() => {
                    toggleInformationPerson();
                  }}
                >
                  <FontAwesomeIcon icon="edit" className="me-2" />
                  <FormattedMessage id="EditInformationPersonsAndConnection" />
                </Button>
              </div>
            </CardFooter>
          </>
        );
      default:
        return;
    }
  };

  const toFormData = (file, paramName) => {
    if (!file) return null;

    var myData = new FormData();
    myData.append(paramName, file);
    return myData;
  };

  const uploadAdditionalDocuments = async () => {
    const participantIds = [];
    period.period.students.forEach((student) => {
      participantIds.push(student.id);
      student.supervisors.forEach((supervisor) => {
        participantIds.push(supervisor.id);
      });
    });

    for (const doc of aplDocumentsWithUsers) {
      var userIds = [];
      for (let index = 0; index < doc.users.length; index++) {
        userIds.push(
          doc.users[index].value.student
            ? doc.users[index].value.student.id
            : doc.users[index].value.id
        );
      }
      if (!doc.users.length) {
        toast.warn(
          "Dokumentet " +
            doc.description +
            " är inte kopplat till någon och kan därför inte laddas upp"
        );
      } else {
        const docdata = await axios
          .post(
            `/Apl/PostDocumentForPeriod?description=${
              doc.description
            }&periodId=${period.period.id}&userIds=${userIds.join(
              "&userIds="
            )}`,
            toFormData(doc.document, "document"),
            { headers: { "Content-Type": "multipart/form-data;" } }
          )
          .catch((err) => {
            toast.warn(err.response.data);
          });
        if (docdata && docdata.status > 199 && docdata.status < 300) {
          toast.success("Dokument sparade");
          setPeriod(prev => ({
            ...prev,
            documents: [...prev.documents, docdata.data.result]
          }));
        }
      }
    }
    setAplDocumentsWithUsers([]);
  };

  const saveInformationPersonsAndUsersForPeriod = (newInfoPersonsWithUsers) => {
    let saveObject = { periodId: period.period.id, users: [] };
    newInfoPersonsWithUsers.forEach((infopers) => {
      let infoPerson = { id: infopers.id, userIds: [] };
      infopers.forUsers.forEach((user) => {
        infoPerson.userIds.push(user.id);
      });
      saveObject.users.push(infoPerson);
    });

    postAplInfoPersonsAndUsers.mutate(saveObject, {
      onSuccess: (data) => {
        mutate(period.period.id, {
          onSuccess: (data) => {
            setInformationPersons(data);
            toast.success("Kontaktpersoner uppdaterade");
            setInformationPersonIsOpen(false);
          },
          throwOnError: true,
          onError: (data) => {
            toast.warn(data.response.data);
          },
        });
      },
    });
  };

  const saveInformationPerson = (person) => {
    postAplInfoPerson.mutate(
      {
        aplPeriodId: period.period.id,
        name: person.name,
        mail: person.mail,
        phoneNumber: person.phoneNumber,
        forUserIds: [],
      },
      {
        onSuccess: (data) => {
          mutate(period.period.id, {
            onSuccess: (data) => {
              setInformationPersons(data);
            },
            throwOnError: true,
            onError: (data) => {
              toast.warn(data.response.data);
            },
          });
        },
        throwOnError: true,
        onError: (data) => {
          toast.warn(data.response.data);
        },
      }
    );
  };

  const handleChange = (event, newValue) => {
    setLevelSupervisor(newValue);
  };

  return (
    <Col lg={12}>
      <Card>
        <Box className="apl-tabs-header">
          <Tabs
            value={levelSupervisor}
            onChange={handleChange}
            indicatorColor="primary"
            textColor="primary"
            variant="scrollable"
            className="apl-tabs"
          >
            <Tab
              disableRipple
              value="supervisor"
              label={
                <div className="d-flex align-items-center px-1">
                  <FontAwesomeIcon icon="user" className="me-2 text-muted" />
                  <span
                    style={{
                      fontWeight:
                        levelSupervisor === "supervisor" ? "600" : "400",
                      letterSpacing: "0.01em",
                    }}
                  >
                    <FormattedMessage id="SupervisorsAndStudents" />
                  </span>
                </div>
              }
              className="apl-tab"
            />
            <Tab
              value="importantPersons"
              label={
                <div className="d-flex align-items-center py-1">
                  <FontAwesomeIcon
                    icon="address-book"
                    className="me-2 text-muted"
                  />
                  <span
                    style={{
                      fontWeight:
                        levelSupervisor === "importantPersons" ? "600" : "400",
                    }}
                  >
                    <FormattedMessage id="ContactPersons" />
                  </span>
                </div>
              }
              className="apl-tab"
            />
            <Tab
              value="documents"
              label={
                <div className="d-flex align-items-center py-2">
                  <FontAwesomeIcon
                    icon="file-alt"
                    className="me-2 text-muted"
                  />
                  <span
                    style={{
                      fontWeight:
                        levelSupervisor === "documents" ? "600" : "400",
                    }}
                  >
                    <FormattedMessage id="Documents" />
                  </span>
                </div>
              }
              className="apl-tab"
            />
          </Tabs>
        </Box>

        {selectSupervisorDocument(levelSupervisor)}

        {period && (
          <Modal isOpen={isOpen} toggle={toggle}>
            <ModalHeader>
              {" "}
              <FormattedMessage id="Documents" />
            </ModalHeader>
            <Card style={{ marginBottom: "0", height: "34rem" }}>
              <CardBody style={{ overflowY: "auto" }}>
                <ModalBody style={{ border: "none", padding: "0" }}>
                  <CreateAPLPeriodDocuments
                    aplDocumentsWithUsers={aplDocumentsWithUsers}
                    setAplDocumentsWithUsers={setAplDocumentsWithUsers}
                    aplStudentSupervisors={period.period.students}
                    students={period.period.students}
                    supervisors={supervisorsInPeriod}
                    isModifying={true}
                  />
                </ModalBody>
              </CardBody>
              <CardFooter>
                <div className="justify-content-end d-flex">
                  <Button
                    outline
                    className="m-2"
                    color="secondary"
                    onClick={toggle}
                  >
                    <FormattedMessage id="Cancel" />
                  </Button>
                  <Button
                    color="primary"
                    outline
                    className="m-2"
                    onClick={() => {
                      uploadAdditionalDocuments();
                      toggle();
                    }}
                  >
                    <FormattedMessage id="Upload" />
                  </Button>
                </div>
              </CardFooter>
            </Card>
          </Modal>
        )}

        {period && supervisorsInPeriod && (
          <ModifyAPLInformationPersonModal
            periodId={period.period.id}
            students={period.period.students}
            supervisors={supervisorsInPeriod}
            setInformationPersons={setInformationPersons}
            informationPersons={informationPersons}
            infoPersonUsers={infoPersonUsers}
            setInfoPersonUsers={setInfoPersonUsers}
            updateInfoPersonAddUsers={updateInfoPersonAddUsers}
            updateInfoPersonRemoveUsers={updateInfoPersonRemoveUsers}
            informationPersonIsOpen={informationPersonIsOpen}
            toggleInformationPerson={toggleInformationPerson}
            saveInformationPerson={saveInformationPerson}
            saveInformationPersonsAndUsersForPeriod={
              saveInformationPersonsAndUsersForPeriod
            }
            level={level}
            objId={objId}
            programId={programId}
          />
        )}
      </Card>
    </Col>
  );
}

const Label = styled.label`
  margin: auto 1rem;
  background: white;
`;

const LabelAsRow = styled(Label)`
  margin: auto 0;
  padding: 0.1rem 0.5rem;
  cursor: pointer;
  background: white;
  &:hover {
    background: #20a8d8;
    color: white;
    cursor: pointer;
    transition: all 0.2s linear;
    border-radius: 1rem;
  }
`;
